import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLess = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.44 0H10.56C15.7736 0 20 4.22643 20 9.44V10.56C20 15.7736 15.7736 20 10.56 20H9.44C4.22643 20 0 15.7736 0 10.56V9.44C0 4.22643 4.22643 0 9.44 0ZM10.56 18.5C14.9315 18.4673 18.4673 14.9315 18.5 10.56V9.44C18.4673 5.06846 14.9315 1.53267 10.56 1.5H9.44C5.06846 1.53267 1.53266 5.06846 1.5 9.44V10.56C1.53266 14.9315 5.06846 18.4673 9.44 18.5H10.56Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14 9.25H6C5.58579 9.25 5.25 9.58579 5.25 10C5.25 10.4142 5.58579 10.75 6 10.75H14C14.4142 10.75 14.75 10.4142 14.75 10C14.75 9.58579 14.4142 9.25 14 9.25Z",
		fill: "currentColor"
	})]
});
export default SvgLess;
